export default "__VITE_ASSET__OcFTLgUX__"